/** @format */

export const propRowHeight = 50;
export const propNodeWidth = 200;
export const propNodeHeight = 30;
export const propPortRadius = 10;
